/** iter43 — Shared datetime helpers so every page renders lifecycle stamps
 *  identically. Timestamps are stored as UTC on the server; the UI shows
 *  Asia/Kolkata (IST, UTC+5:30, no DST) in 12-hour format.
 */

/** DD/MM/YYYY (date-only) — kept for backward compatibility with older code. */
export function fmtDDMMYYYY(v) {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

/** `18 Sep 2026 · 07:35 PM IST` — the canonical lifecycle-stamp format.
 *  Uses toLocaleString with the Asia/Kolkata IANA zone so DST logic (n/a for IST
 *  but future-proof) and locale month abbreviations are handled by the runtime.
 */
export function fmtIST(v) {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  const opts = {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
    timeZone: 'Asia/Kolkata',
  };
  // en-GB gives us `18 Sep 2026, 07:35 pm` — normalise the separator + case
  // so every page shows `18 Sep 2026 · 07:35 PM IST` consistently.
  const raw = d.toLocaleString('en-GB', opts).replace(',', ' ·');
  return `${raw.replace(/am|pm/i, (m) => m.toUpperCase())} IST`;
}

/** Date-only in IST for compact table cells: `18 Sep 2026`. */
export function fmtISTDateOnly(v) {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  return d.toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
    timeZone: 'Asia/Kolkata',
  });
}
